"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialModelBase = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var inversify_1 = require("inversify");
var data_1 = require("../data");
var interfaces_2 = require("../interfaces");
var SocialModelBase = (function (_super) {
    tslib_1.__extends(SocialModelBase, _super);
    function SocialModelBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.session = new data_1.SessionData();
        _this.showPauseOverlay = false;
        return _this;
    }
    SocialModelBase.prototype.startGameAsync = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2];
            });
        });
    };
    SocialModelBase.prototype.getFriendById = function (id, friends) {
        return;
    };
    SocialModelBase.prototype.init = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2];
        }); });
    };
    SocialModelBase.prototype.playSolo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2];
            });
        });
    };
    SocialModelBase.prototype.playOffline = function (tag) {
        if (tag === void 0) { tag = "default"; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, interfaces_2.SOCIAL_POPUP.FAILED];
            });
        });
    };
    SocialModelBase.prototype.playWith = function (idOrOpponent, instantResolve) {
        if (instantResolve === void 0) { instantResolve = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, interfaces_2.SOCIAL_POPUP.FAILED];
            });
        });
    };
    SocialModelBase.prototype.notify = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, false];
            });
        });
    };
    SocialModelBase.prototype.showShortcutPopup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, false];
            });
        });
    };
    SocialModelBase.prototype.showBotPopup = function (ref) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, false];
            });
        });
    };
    SocialModelBase.prototype.share = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, false];
            });
        });
    };
    SocialModelBase.prototype.switchGame = function (id, data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2];
        }); });
    };
    SocialModelBase.prototype.invite = function (options, instantResolve) {
        if (instantResolve === void 0) { instantResolve = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, interfaces_2.SOCIAL_POPUP.FAILED];
            });
        });
    };
    SocialModelBase.prototype.getRandomChallenger = function (ignoreUsers) {
        if (ignoreUsers === void 0) { ignoreUsers = []; }
        return undefined;
    };
    SocialModelBase.prototype.getRandomOpponent = function () {
        return undefined;
    };
    SocialModelBase.prototype.syncLeaderboards = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2];
            });
        });
    };
    SocialModelBase.prototype.postSessionScore = function (score) {
    };
    Object.defineProperty(SocialModelBase.prototype, "me", {
        get: function () {
            return this.nobody;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SocialModelBase.prototype, "opponent", {
        get: function () {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SocialModelBase.prototype, "contextPlayers", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SocialModelBase.prototype, "inSolo", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SocialModelBase.prototype, "inGroup", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SocialModelBase.prototype, "friends", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SocialModelBase.prototype, "socialPlatform", {
        get: function () {
            return "web";
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.cookie),
        tslib_1.__metadata("design:type", Object)
    ], SocialModelBase.prototype, "cookie", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.payments),
        tslib_1.__metadata("design:type", Object)
    ], SocialModelBase.prototype, "payments", void 0);
    tslib_1.__decorate([
        (0, core_1.lazyInject)(interfaces_1.TypesSocial.dummyUser),
        tslib_1.__metadata("design:type", Object)
    ], SocialModelBase.prototype, "nobody", void 0);
    SocialModelBase = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], SocialModelBase);
    return SocialModelBase;
}(core_1.EventDispatcher));
exports.SocialModelBase = SocialModelBase;
//# sourceMappingURL=SocialModelBase.js.map